export default {
  name: 'UserModelPermissions',

  data () {
    return {
      userModelPermissions: [],
      tableItems: [],
      isLoading: false,
      paging: { limit: 20, page: 1, total: 0, pages: 0 }
    }
  },

  props: {
    userId: {
      type: Number | String,
      default: null
    }
  },

  computed: {
    canSeeModelPermissions () {
      return this.ApiRequest.userHasPermission('view-model-permissions');
    },
    tableHeaders () {
      return [
        { key: 'name', label: this.$t('user-model-permissions.permission') },
        { key: 'granted_created_at', label: this.$t('user-model-permissions.granted_created_at'), type: 'datetime' },
        { key: 'reason', label: this.$t('user-model-permissions.reason') }
      ];
    }
  },

  methods: {
    loadUserModelPermissions () {
      if (!this.canSeeModelPermissions) {
        return;
      }
      this.isLoading = true;
      this.ApiRequest.request('user-model-permissions?api_id=' + this.userId, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.error) {
          console.log(response.error)
        } else {
          this.tableItems = response.data;
        }
        this.isLoading = false;
      });
    }
  },

  mounted () {
    this.loadUserModelPermissions();
  }
}
